import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

import type { FlexGapProps } from 'common/theme/system-utilities';
import { flexGap } from 'common/theme/system-utilities';
import Icon from '../Icon';
import { SubtitleST4 } from '../Typography';
import { BaseTabButton } from './TabItem';

interface GalleryTabMenu3DButtonProps {
  isActive?: boolean;
  onClick?: () => void;
}

const Styled3DButton = styled(BaseTabButton)<GalleryTabMenu3DButtonProps & FlexGapProps>`
  ${flexGap};
  &:only-child {
    &:hover,
    &:focus-visible,
    &[aria-pressed='true'] {
      ${props => `border: 1px solid ${themeGet('colors.sys.neutral.border.active')(props)};`}
    }

    gap: 4px;
  }

  justify-content: center;
`;

export const GalleryTabMenu3DButton = ({
  isActive = false,
  onClick,
}: GalleryTabMenu3DButtonProps) => (
  <Styled3DButton
    isActive={isActive}
    tabIndex={0}
    pl="sp_8"
    pr="sp_12"
    onClick={onClick}
    type="button"
    aria-pressed={isActive}
    aria-label="3D"
    justifyContent="center"
  >
    <Icon name="cube" size="20px" fill="sys.neutral.icon.default" />
    <SubtitleST4 color={isActive ? 'sys.neutral.text.active' : 'sys.neutral.text.default'}>
      3D
    </SubtitleST4>
  </Styled3DButton>
);

GalleryTabMenu3DButton.displayName = 'GalleryTabMenu3DButton';
